// AppConstant.js
export const MSG_DURATION = 5;


// Assessment Constant


export const MIN_RECORDING_DURATION = 20;
